import { createSelector } from '@reduxjs/toolkit';
import { selectTargetLoan, selectCurrentLoan } from '../selectors';
import { selectBalanceSupportedTokenObj } from 'src/store/shared/balances/selectors';
import { getColdWalletsSelectors } from 'src/store/shared/cold-wallets/selectors';
import type { TokenTypeMap } from 'src/store/shared/cold-wallets/types';

const selectSupportById = createSelector(
  selectCurrentLoan,
  selectBalanceSupportedTokenObj,
  (loan, supportedTokens) => {
    if (!loan) return [];
    return supportedTokens?.[loan.id] ?? [];
  },
);

const selectTokenTypeMap = createSelector(selectSupportById, (supportedTokens) =>
  (supportedTokens ?? []).reduce<TokenTypeMap>(
    (acc, { token, type }: { token: string; type: number }) => {
      acc[token] = type;
      return acc;
    },
    {},
  ),
);

export const { selectWalletsSnapshots, selectColdWallets } = getColdWalletsSelectors(
  selectTargetLoan,
  selectTokenTypeMap,
);
